<template>
  <div class="faq-block">
    <h3 class="faq-title">{{ __('website.tariffs.h2.FAQ') }}</h3>
    <div class="content-wrap">
      <QuestionsAccordion />
      <ReviewCarousel />
    </div>
  </div>
</template>

<script>
import QuestionsAccordion from './QuestionsAccordion';
import ReviewCarousel from './ReviewCarousel';

export default {
  name: 'FaqBlock',

  components: {
    QuestionsAccordion,
    ReviewCarousel,
  },
};
</script>

<style lang="sass" scoped>
.faq-block
  margin: 40px auto 0
  max-width: 1135px
.faq-title
  color: #2C2C2C
  font-size: 34px
  line-height: 48px
  font-weight: 700
  text-align: center
  margin: 0 0 16px
  padding: 12px 0
.content-wrap
  display: flex

@media screen and (max-width: 990px)
  .content-wrap
    display: block
</style>